import FaqWidget from './FaqWidget'

export default FaqWidget
